import { render, staticRenderFns } from "./ViewStockTake.vue?vue&type=template&id=64ab0ec1&"
import script from "./ViewStockTake.vue?vue&type=script&lang=js&"
export * from "./ViewStockTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports